import { call, put, takeEvery } from 'redux-saga/effects';
import { getBlemishReport } from '../../../requests/leads_questions/get_blemish_report_request';
import {
    getBlemishReportSuccess,
    getBlemishReportFailure,
    getBlemishFieldSuccess,
} from '../../actions/questions_actions/get_blemish_report.actions';
import { GET_BLEMISH_REPORT_REQUEST } from '../../constants/questions_constants/get_blemish_report.constants';

function* getBlemishReportRequest({ lead_id, field }) {
    const { result, options, error } = yield call(getBlemishReport, lead_id, field);

    if (result) {
        if (field) {
            yield put(getBlemishFieldSuccess(options[field], field));
        } else {
            yield put(getBlemishReportSuccess(options));
        }
    } else {
        yield put(getBlemishReportFailure(error));
    }
}

export default function* getBlemishReportSaga() {
    yield takeEvery(GET_BLEMISH_REPORT_REQUEST, getBlemishReportRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/questions.sagas/get_blemish_report.saga.js